<template>
  <b-modal
    :visible="value"
    size="md"
    title="Cancel repeat prescription"
    @change="$emit('input', $event)"
    @hidden="onHidden"
  >
    <p v-if="patientLabel" class="mb-2">
      <strong>Order {{ orderItemId }}</strong>
      <span v-if="patientLabel"> — {{ patientLabel }}</span>
    </p>
    <p class="text-muted">
      This stops further repeats on this order only. The reason is recorded and the patient receives a cancellation email.
    </p>
    <b-form-group label="Cancellation reason" label-for="repeatCancelReason">
      <b-form-textarea
        id="repeatCancelReason"
        v-model="reason"
        rows="3"
        placeholder="e.g. Patient requested cancellation — received another prescription"
        :state="reasonState"
      />
      <b-form-invalid-feedback>A reason is required.</b-form-invalid-feedback>
    </b-form-group>
    <b-alert v-if="error" show variant="danger" class="mb-0">{{ error }}</b-alert>

    <template v-slot:modal-footer>
      <b-button variant="secondary" :disabled="submitting" @click="$emit('input', false)">Go back</b-button>
      <b-button variant="danger" :disabled="submitting" @click="submit">
        <b-spinner small v-if="submitting" class="mr-1" />
        Cancel repeat prescription
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'CancelRepeatPrescriptionModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderItemId: {
      type: [Number, String],
      required: true
    },
    patientLabel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      reason: '',
      error: '',
      submitting: false,
      touched: false
    };
  },
  computed: {
    reasonState () {
      if (!this.touched) {
        return null;
      }
      return (this.reason || '').trim().length > 0;
    }
  },
  watch: {
    value (open) {
      if (open) {
        this.reason = '';
        this.error = '';
        this.submitting = false;
        this.touched = false;
      }
    }
  },
  methods: {
    onHidden () {
      this.reason = '';
      this.error = '';
      this.submitting = false;
      this.touched = false;
    },
    submit () {
      this.touched = true;
      const text = (this.reason || '').trim();
      if (!text) {
        return;
      }
      this.error = '';
      this.submitting = true;
      this.$repeatPrescriptionService.cancelRepeatPrescription(this.orderItemId, text)
        .then(() => {
          this.$emit('input', false);
          this.$emit('success', { orderItemId: this.orderItemId, reason: text });
        })
        .catch(err => {
          this.submitting = false;
          const message = err.response && err.response.data && err.response.data.message;
          this.error = typeof message === 'string' && message
            ? message
            : 'Could not cancel this repeat. It may already be cancelled or completed.';
        });
    }
  }
};
</script>
